import {
  colors,
  ImpButton,
  ImpContainer,
  ImpDivider,
  ImpFlex,
  ImpPad,
  ImpSpacer,
  ImpSurface,
  ImpText,
  spacing,
} from '@imprint-payments/imprint-ui';
import { useStatsigClient } from '@statsig/react-bindings';
import QRCode from 'qrcode.react';
import { useEffect } from 'react';

import { EVENT } from '../analytics/analyticsConsts';
import { useImpState } from '../app/hooks';
import {
  IMPRINT_STORE_HELP_URL,
  type LandingPageURLKey,
  PARAM_SHOW_WPP,
} from '../assets/consts/inStoreConsts';
import { navigateToLP } from '../components/application/InStoreModal';
import { HeaderHandler } from '../components/HeaderHandler/HeaderHandler';
import { ANALYTICS } from '../firebase/firebase';
import Gates from '../statsig/gates';
import { getDomainFromMerchant } from '../utils/environments';
import { usePostAcceptPage } from './CreatePINPage';

export function CompleteOnPhonePage() {
  const { merchantData, language } = useImpState();
  const { checkGate } = useStatsigClient();

  usePostAcceptPage();

  useEffect(() => {
    ANALYTICS.logEvent(EVENT.offerModalViewed);
  }, []);

  const qrLink = checkGate(Gates.AddToWalletGate)
    ? makeLoginQrLink()
    : IMPRINT_STORE_HELP_URL;

  return (
    <div>
      <HeaderHandler />
      <ImpSpacer height="2xl" mobileHeight="xl" />
      <ImpFlex fluid justify="center">
        <ImpPad padding="0px 16px">
          <ImpContainer
            borderRadius="12px"
            border={`1px solid ${colors.border.borderVariant}`}
          >
            <ImpSurface fluid hasBorderRadius>
              <ImpPad paddingTop="2xl" paddingBottom="xl">
                <ImpFlex
                  gap="3xl"
                  mobileGap="3xl"
                  direction="column"
                  fluid
                  align="center"
                >
                  <ImpFlex align="center" direction="column" fluid>
                    <ImpContainer
                      textAlign="center"
                      maxWidth="600px"
                      width="100%"
                    >
                      <ImpPad paddingLeft="xl" paddingRight="xl">
                        <ImpText
                          color={'var(--merchant-color)'}
                          typography="display3"
                        >
                          {language.scanQRUseCardNow}
                        </ImpText>
                        <ImpSpacer height={spacing.s} />
                        <ImpText
                          color={'var(--merchant-color)'}
                          typography="headline3"
                        >
                          {language.orClickTheLink}
                        </ImpText>
                      </ImpPad>
                    </ImpContainer>
                  </ImpFlex>
                  <ImpContainer
                    backgroundColor={'var(--merchant-color)'}
                    borderRadius={spacing.s}
                  >
                    <ImpPad padding={spacing.s}>
                      <QRCode
                        value={qrLink}
                        size={132}
                        fgColor={colors.content.onSurface}
                      />
                    </ImpPad>
                  </ImpContainer>

                  <ImpFlex align="center" fluid direction="column">
                    <ImpDivider color={'var(--merchant-color)'} />
                    <ImpSpacer height={spacing.xl} />
                    <ImpButton
                      onClick={() =>
                        navigateToLP(
                          merchantData.productUUID as LandingPageURLKey
                        )
                      }
                      variant="secondary"
                      buttonStyle="color"
                      color={'var(--merchant-color)'}
                    >
                      {language.goBackToLP}
                    </ImpButton>
                  </ImpFlex>
                </ImpFlex>
              </ImpPad>
            </ImpSurface>
          </ImpContainer>
        </ImpPad>
      </ImpFlex>
    </div>
  );

  function makeLoginQrLink() {
    const loginUrl: string = getDomainFromMerchant(''); // login link
    const qrUrl = new URL(loginUrl);

    // Use URLSearchParams to manage the query parameters
    const params = new URLSearchParams(qrUrl.search);
    params.set(PARAM_SHOW_WPP, 'true'); // Add or update the parameter

    // Set the modified search parameters back to the URL
    qrUrl.search = params.toString();

    return qrUrl.toString();
  }
}
